__webpack_require__.p = "/++plone++senaite.core.static/bundles/";